import { render, staticRenderFns } from "./product.vue?vue&type=template&id=61c2cd9c&scoped=true"
import script from "./product.vue?vue&type=script&lang=js"
export * from "./product.vue?vue&type=script&lang=js"
import style0 from "./product.vue?vue&type=style&index=0&id=61c2cd9c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c2cd9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61c2cd9c')) {
      api.createRecord('61c2cd9c', component.options)
    } else {
      api.reload('61c2cd9c', component.options)
    }
    module.hot.accept("./product.vue?vue&type=template&id=61c2cd9c&scoped=true", function () {
      api.rerender('61c2cd9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/platformActivity/product.vue"
export default component.exports